import styled from 'styled-components';

export const Container = styled.div``;

export const H6b = styled.h6`
  font-weight: bold;
`;

export const H6 = styled.h6``;
